import { render, staticRenderFns } from "./ModalDragbtoc.vue?vue&type=template&id=5ceb64ac&scoped=true"
import script from "./ModalDragbtoc.vue?vue&type=script&lang=js"
export * from "./ModalDragbtoc.vue?vue&type=script&lang=js"
import style0 from "./ModalDragbtoc.vue?vue&type=style&index=0&id=5ceb64ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb64ac",
  null
  
)

export default component.exports